<script>
  import {addDays, format, parse} from 'date-fns';
  import {es} from 'date-fns/locale';
  import CampoDeFecha from "../../Components/UI/CampoDeFecha.svelte";

  import {descarga} from '../../Api/marcajes';
  import store from '../../Stores/marcajes-store';
  import storeTrabajadores from '../../Stores/trabajadores-store';
  import storeGrupos from '../../Stores/grupos-store';
  import storeSedes from '../../Stores/sedes-store';
  import storeMotivos from '../../Stores/motivos-store';
  import storeTiposDeJornada from '../../Stores/tipos-de-jornada-store';
  import storeTiposDeIncidencia from '../../Stores/tipos-de-incidencia-store';
  import SelectorDeTrabajadores from "../../Components/UI/SelectorDeTrabajadores.svelte";
  import Titulo from "../../Components/UI/Titulo.svelte";
  import Caja from "../../Components/UI/Caja.svelte";
  import Tabla from '../../Components/Marcajes/Tabla.svelte';
  import Loading from "../../Components/UI/Loading.svelte";
  import CampoDeSeleccion from "../../Components/UI/CampoDeSeleccion.svelte";
  import {horasTrabajadas, nombreCompleto} from '../../Modelos/Trabajador';
  import Subtitulo from "../../Components/UI/Subtitulo.svelte";
  import Boton from "../../Components/UI/Boton.svelte";
  import Duracion from "../../Components/UI/Duracion.svelte";
  import Diferencia from "../../Components/UI/Diferencia.svelte";

  storeTrabajadores.cargar();
  storeGrupos.cargar();
  storeSedes.cargar();
  storeTiposDeJornada.cargar();

  const opcionesDeAgrupacion = [
    {valor: 'sin-agrupar', etiqueta: 'Sin agrupar'},
    {valor: 'departamento', etiqueta: 'Departamento'},
    {valor: 'trabajador', etiqueta: 'Trabajador'},
    {valor: 'dia', etiqueta: 'Día'},
    {valor: 'semana', etiqueta: 'Semana'},
    {valor: 'mes', etiqueta: 'Mes'},
  ];

  let fecha = new Date(), inicio = addDays(fecha, -7), fin = fecha, agrupacion = 'sin-agrupar';

  let trabajadores, trabajadoresElegidos, marcajes, gruposDeUsuarios, grupoElegido = -1,
      todosLosTrabajadores, tiposDeIncidencia, tipoDeIncidenciaElegido = -1, motivoElegido = -1,
      sedes, sedeElegida = -1;

  $: tiposDeIncidencia = ($storeTiposDeIncidencia.listado || []).map(x => ({
    valor: x.id,
    etiqueta: x.nombre
  }));

  $: tipos = $storeTiposDeJornada.listadoIndexado
  $: motivos = ($storeMotivos.listado || []).map(x => ({valor: x.id, etiqueta: x.nombre}));

  $: todosLosTrabajadores = $storeTrabajadores.listado || [];

  $: trabajadores = grupoElegido !== -1 ? todosLosTrabajadores.filter(x => x.grupo && x.grupo.id === grupoElegido) : todosLosTrabajadores
  $: trabajadoresElegidos = trabajadores;

  $: gruposDeUsuarios = ($storeGrupos.listado || []).map(grupo => ({
    valor: grupo.id,
    etiqueta: grupo.nombre
  }));

  $: sedes = ($storeSedes.listado || []).map(sede => ({valor: sede.id, etiqueta: sede.nombre}));

  $: marcajes = $store.listado;

  const filtrar = () => store.buscar(inicio, fin, trabajadoresElegidos, tipoDeIncidenciaElegido, motivoElegido, sedeElegida);
  $: $storeTrabajadores.listado.length && filtrar();

  const limpiar = () => {
    fecha = new Date();
    inicio = addDays(fecha, -7);
    fin = fecha;
    sedeElegida = -1;
    grupoElegido = -1;
    trabajadores = $storeTrabajadores.listado;
    agrupacion = 'sin-agrupar';
    sentido = 'Descendente';
    tipoDeIncidenciaElegido = -1;
    motivoElegido = -1;
    setTimeout(filtrar, 100);
  }

  let sentido = 'Descendente';

  let grupos;
  $: {
    switch (agrupacion) {
      case 'trabajador':
        grupos = trabajadoresElegidos.map(x => ({
          titulo: nombreCompleto(x),
          marcajes: marcajes.filter(y => y.trabajador === x.id)
        }));
        break;
      case 'departamento': {
        grupos = gruposDeUsuarios.map(departamento => ({
          titulo: departamento.etiqueta,
          marcajes: marcajes.filter(y => {
            const trabajador = trabajadoresElegidos.filter(x => x.id === y.trabajador)[0];
            return trabajador && trabajador.grupo && trabajador.grupo.id === departamento.valor;
          })
        }));

        const sinGrupo = trabajadoresElegidos.filter(x => !x.grupo);
        if (sinGrupo) {
          grupos.push({
            titulo: 'Sin grupo',
            marcajes: marcajes.filter(y => sinGrupo.filter(x => x.id === y.trabajador)[0])
          })
        }
        break;
      }
      case 'dia':
        const diasUnicos = [...new Set(marcajes.map(x => x.dia))];
        grupos = diasUnicos.map(dia => ({
          titulo: format(parse(dia, 'yyyy-MM-dd', new Date()), "dd 'de' LLLL 'de' yyyy", {locale: es}),
          marcajes: marcajes.filter(y => y.dia === dia)
        }));
        break;
      case 'semana':
        const semanas = [...new Set(marcajes.map(({dia}) => {
          const fecha = parse(dia, 'yyyy-MM-dd', new Date());
          return format(fecha, 'RRRR-I');
        }))];

        grupos = semanas.map(s => {
          const [anio, semana] = s.split('-');
          return {
            titulo: `Semana ${semana} de ${anio}`,
            marcajes: marcajes.filter(({dia}) => {
              const fecha = parse(dia, 'yyyy-MM-dd', new Date());
              return format(fecha, 'yyyy-I') === s;
            })
          };
        });
        break;
      case 'mes':
        const mesesUnicos = [...new Set(marcajes.map(x => x.dia.substring(0, 7)))];
        grupos = mesesUnicos.map(mes => ({
          titulo: format(parse(mes, 'yyyy-MM', new Date()), "LLLL 'de' yyyy", {locale: es}),
          marcajes: marcajes.filter(({dia}) => dia.substring(0, 7) === mes)
        }));
        break;
      default:
        grupos = null;
        break;
    }

    grupos = grupos && grupos.map(grupo => {
      const [previstas, trabajadas] = grupo.marcajes.reduce((acc, marcaje) => {
        return [
          acc[0] + ($storeTiposDeJornada.listadoIndexado[marcaje.tipo].duracion || 0),
          acc[1] + horasTrabajadas(marcaje.horas)
        ];
      }, [0, 0]);

      return {...grupo, previstas, trabajadas};
    });
  }

  const descargar = () => {
    descarga(inicio, fin, trabajadoresElegidos, agrupacion, sentido, tipoDeIncidenciaElegido, motivoElegido, sedeElegida)
        .then(x => {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(x.data);
          a.download = 'marcajes.xlsx';
          document.body.append(a);
          a.click();
          a.remove();
        })
        .catch(e => alert(e));
  };

  const imprimir = () => window.print();
</script>

<style>
    .contenido {
        display: grid;
        margin-top: var(--padding-global);
        grid-gap: var(--padding-global);
        grid-template-columns: 1fr;
        grid-template-rows: max-content 1fr;
    }

    .campos {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(18em, 1fr));
        grid-gap: 0 var(--padding-global);
        align-items: end;
    }

    .buscar {
        padding-bottom: .5rem;
    }

    .cargando {
        position: absolute;
        width: 100%;
    }

    @media only print {
        .botones {
            display: none;
        }
    }
</style>

<svelte:head>
    <title>Marcajes</title>
</svelte:head>

<Titulo>Marcajes</Titulo>

<Caja pie={false}>
    <div slot="titulo">
        <Subtitulo>Filtro</Subtitulo>
    </div>

    <div slot="botones" class="botones">
        <Boton tamano="pequeno" icono="cloud_download" on:click={descargar}>Descargar
        </Boton>
        <Boton tamano="pequeno" icono="print" on:click={imprimir}>Imprimir</Boton>
    </div>

    <div class="filtro">
        <div class="campos">
            <div class="inicio">
                <CampoDeFecha id="fecha" label="Desde" value={inicio}
                              on:change={e => inicio = e.detail}/>
            </div>

            <div class="fin">
                <CampoDeFecha id="fin" label="Hasta" value={fin}
                              on:change={e => fin = e.detail}/>
            </div>

            <div class="sede">
                <CampoDeSeleccion icono="group_work" id="grupos" label="Sede"
                                  opciones={sedes} value={sedeElegida} vacio="Todas"
                                  on:input={e => sedeElegida = parseInt(e.target.value, 10) || -1 }/>
            </div>

            <div class="departamento">
                <CampoDeSeleccion icono="group_work" id="grupos" label="Departamento"
                                  opciones={gruposDeUsuarios} value={grupoElegido} vacio="Todos"
                                  on:input={e => grupoElegido = parseInt(e.target.value, 10) || -1 }/>
            </div>

            <div class="trabajador">
                <SelectorDeTrabajadores id="trabajadores" label="Trabajadores"
                                        value={trabajadoresElegidos}
                                        {trabajadores}
                                        on:change={e => trabajadoresElegidos = e.detail}/>
            </div>

            <div class="agrupacion">
                <CampoDeSeleccion icono="group_work" id="agrupacion" label="Agrupar por"
                                  opciones={opcionesDeAgrupacion} value={agrupacion} vacio={false}
                                  on:input={e => agrupacion = e.target.value}/>
            </div>

            <div class="orden">
                <CampoDeSeleccion icono="sort" id="orden" label="Orden" vacio={false}
                                  opciones={['Ascendente', 'Descendente']} value={sentido}
                                  on:input={e => sentido = e.target.value}/>
            </div>

            <div class="incidencia">
                <CampoDeSeleccion icono="warning" id="incidencia" label="Incidencia"
                                  vacio="Ninguna" valorVacio="-1"
                                  opciones={tiposDeIncidencia} value={tipoDeIncidenciaElegido}
                                  on:input={e => tipoDeIncidenciaElegido = parseInt(e.target.value, 10)}/>
            </div>

            <div class="orden">
                <CampoDeSeleccion icono="call_split" id="motivo" label="Motivo" valorVacio="-1"
                                  opciones={motivos} value={motivoElegido} vacio="Cualquiera"
                                  on:input={e => motivoElegido = parseInt(e.target.value, 10)}/>
            </div>
        </div>

        <p style="text-align:right">
            <Boton on:click={limpiar} tipo="ok">
                Limpiar filtro
            </Boton>

            <Boton on:click={filtrar} tipo="ok">
                Filtrar
            </Boton>
        </p>
    </div>
</Caja>
<div class="contenido">
    {#if $store.cargando || $storeTiposDeJornada.cargando}
        <div class="cargando">
            <Loading/>
        </div>
    {:else if agrupacion === 'sin-agrupar'}
        <Caja cabecera={false}>
            <Tabla marcajes={sentido === 'Ascendente' ? marcajes : marcajes.reverse()}/>
        </Caja>
    {:else}
        {#each grupos as grupo}
            <Caja plegable>
                <div slot="titulo">
                    <div class="grupo-titulo">
                        <Subtitulo>{grupo.titulo}</Subtitulo>

                        <div class="grupo-datos">
                            Horas trabajadas:
                            <Duracion minutos={grupo.trabajadas}/>
                            / Horas previstas:
                            <Duracion minutos={grupo.previstas}/>
                            / Diferencia:
                            <Diferencia previsto={grupo.previstas}
                                        trabajado={grupo.trabajadas}/>
                        </div>
                    </div>
                </div>
                <Tabla marcajes={sentido === 'Ascendente' ? grupo.marcajes : [...grupo.marcajes].reverse()}/>
            </Caja>
        {/each}
    {/if}
</div>